module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-14.0c6bddeb.png";